/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions,react/prop-types */
import React, { useState, useRef, useEffect } from 'react';
import {
  string,
  arrayOf,
  shape,
  bool,
  number,
  func,
} from 'prop-types';
import _ from 'lodash';
import { nth } from 'ramda';
import {
  Collapsible,
  Card,
  Button,
  PromotionalBanner,
  Modal,
  Heading,
  Icon,
  RadioControl,
} from 'components/common';
import { Link } from '@hyphengroup/cag-components';
import { getPageRoute, onCtaClick } from 'helpers/Utils';
import { withTracking } from 'components/tracking';
import { addEventListener } from 'consolidated-events';
import withApplicationConfig from 'containers/withApplicationConfig';
import { isUseCountdown, isUseFlipBanner } from 'pages/Verticals/ResultsPage/ResultsPageUtils';
import Header, { staticTextKeys as headerLabelStaticTextKeys } from 'components/product/ProductPane/Header';
import AccordionPanel, { staticTextKeys as accordionPanelStaticTextKeys } from 'components/product/ProductPane/AccordionPanel';
import { comparablesMappingHandler } from 'components/tracking/TrackingUtils';
import { onKGIPopupApplyButtonClick, onKGIPopupEvent, ramdaDebounce } from 'money101/TWUtils';
import MobileButtonGroup, { staticTextKeys as mobileButtonGroupStaticTextKeys } from './MobileButtonGroup';
import TabletCtaButtonRow, { staticTextKeys as tabletCtaButtonRowStaticTextKeys } from './TabletCtaButtonRow';
import Row from './Row';
import './ProductPane.scss';

export const staticTextKeys = [
  'RESULTS_PAGE_PROMOTIONAL_LABEL_FEATURED',
  'defaultCTALabel',
  'accordionShowLess',
  'accordionShowMore',
  ...mobileButtonGroupStaticTextKeys,
  ...accordionPanelStaticTextKeys,
  ...tabletCtaButtonRowStaticTextKeys,
  ...headerLabelStaticTextKeys,
];

const ConditionFlipWrapper = ({ condition, wrapper, children }) => (condition
  ? wrapper(children) : children);

const KGIFlow = [
  'COMPANY_TPYE',
  'HAVE_MORE_THAN_ONE_YEAR_CC',
  'FINAL_QUESTION',
  'RESULT',
  'ERR',
];

const ProductPane = (props) => {
  const {
    promotional,
    featured,
    countdownFormat,
    comparables = [],
    offers,
    apr,
    fees,
    eligibilityCriteria,
    termsAndConditions,
    updatedAt,
    description,
    imageDimensions,
    provider,
    image,
    features,
    ctaButton,
    documents,
    productName,
    index,
    imageOrientation,
    staticText,
    onCtaLinkClick,
    list,
    verticalEnum,
    disclaimer,
    urlAliasInfo,
    vertical,
    language,
    ccProductPageRoutes,
    providerProductPageRoute,
    excludedCountries,
    allCountries,
    selectedInsuranceType,
    selectedRegion,
    region,
    title,
    lazyLoadImg,
    isLearnMore,
    onLearnMoreClick,
    enableFlipBanner,
  } = props;

  const DESKTOP_IMAGE = promotional?.flipBanner?.imageForDesktop?.url;
  const MOBILE_IMAGE = promotional?.flipBanner?.imageForMobile?.url;
  const FLIP_FREQUENCY = (promotional?.flipBanner?.period || 5) * 1000;
  const FLIP_START_SEC = (promotional?.flipBanner?.timeDelay || 0) * 1000;

  const [isAccordionPanelShow, setIsAccordionPanelShow] = useState(false);
  const [timerValue, setTimerValue] = useState(0);
  const [heightValue, setHeightValue] = useState(0);
  const flipTimer = useRef(null);
  const frontRef = useRef(null);
  const backRef = useRef(null);

  const canFlipRef = useRef(false);
  const canCountdownRef = useRef(false);

  const [showModal, setShowModal] = useState(false);
  const [KGIAnswer, setKGIAnswer] = useState({
    COMPANY_TPYE: '',
    HAVE_MORE_THAN_ONE_YEAR_CC: '',
    FINAL_QUESTION: '',
    RESULT: '',
    ERR: '',
  });
  const [activeQuestion, setActiveQuestion] = useState(0);

  const KGIQuestion = {
    COMPANY_TPYE: {
      title: '請問您是否任職於政府機關、教育機構/醫院、上市/上櫃/知名企業、軍職或金融同業？',
      subTitle: '問題一',
      radioGroup: [
        { label: '是', value: 'Y' },
        { label: '否', value: 'N' },
      ],
      btnGroup: [
        { label: '下一題' },
      ],
    },
    HAVE_MORE_THAN_ONE_YEAR_CC: {
      title: '請問您是否持有任一信用卡滿一年？',
      subTitle: '問題二',
      radioGroup: [
        { label: '是', value: 'Y' },
        { label: '否', value: 'N' },
      ],
      btnGroup: [
        { label: '上一題' },
        { label: '下一題' },
      ],
    },
    FINAL_QUESTION: {
      title: KGIAnswer.HAVE_MORE_THAN_ONE_YEAR_CC === 'Y' ? '請問您近3個月的信用卡款項是否都準時繳款？' : '請問您是否有中華電信門號？',
      subTitle: '問題三',
      radioGroup: [
        { label: `${KGIAnswer.HAVE_MORE_THAN_ONE_YEAR_CC === 'Y' ? '是，都準時繳款' : '有'}`, value: 'Y' },
        { label: `${KGIAnswer.HAVE_MORE_THAN_ONE_YEAR_CC === 'Y' ? '否，沒有準時繳款' : '沒有'}`, value: 'N' },
      ],
      btnGroup: [
        { label: '上一題' },
        { label: '送出' },
      ],
    },
    RESULT: {
      title: '感謝您的回答！',
      subTitle: '即將帶您前往凱基銀行申貸頁面。',
      btnGroup: [
        { label: '立即前往' },
      ],
    },
    ERR: {
      title: '感謝您的回答！',
      subTitle: '很抱歉！凱基銀行目前沒有適合您的貸款商品，請參考其他銀行的貸款商品。',
      btnGroup: [
        { label: '找尋更適合您的產品' },
      ],
    },
  };

  if (!canCountdownRef.current) {
    canCountdownRef.current = isUseCountdown(promotional);
  }

  if (!canFlipRef.current) {
    canFlipRef.current = isUseFlipBanner(promotional) && enableFlipBanner;
  }

  const toggleAccordionPanel = () => {
    setIsAccordionPanelShow(prev => !prev);

    const {
      track,
      title: sku,
    } = props;
    if (productName && !isAccordionPanelShow) {
      const trackingData = {};
      trackingData.event = 'featureClick';
      trackingData.ecommerce = {
        click: {
          product: [
            {
              name: productName || '',
              list,
              sku,
            },
          ],
        },
      };
      track({ data: trackingData });
    }
  };

  const pauseTimer = () => {
    clearInterval(flipTimer.current);
    flipTimer.current = null;
  };

  const checkHeight = () => {
    if (!canFlipRef.current
      || frontRef.current.offsetHeight > backRef.current.offsetHeight) {
      setHeightValue(`${frontRef.current.offsetHeight}px`);
    } else {
      setHeightValue(`${backRef.current.offsetHeight}px`);
    }
  };

  const runTimer = () => {
    if (!heightValue) checkHeight();
    if (canFlipRef.current && !flipTimer.current) {
      if (timerValue === 0) setTimerValue(val => val + 1);
      flipTimer.current = setInterval(() => {
        setTimerValue(val => val + 1);
      }, FLIP_FREQUENCY);
    }
  };

  const getPromotionalLabels = () => {
    const labels = promotional ? promotional.type.slice(0) : [];
    if (featured) {
      labels.push({
        key: 'FEATURED',
        display: props.staticText.RESULTS_PAGE_PROMOTIONAL_LABEL_FEATURED,
      });
    }

    if (canCountdownRef.current) {
      labels.push({
        key: 'TIME_LIMITED_COUNT',
        countdownFormat: {
          ...countdownFormat,
          ...promotional?.countdown,
          ...promotional?.date,
          loadingText: props.staticText.RESULTS_PAGE_PROMOTIONAL_LABEL_LOADING_TEXT,
          endText: props.staticText.RESULTS_PAGE_PROMOTIONAL_LABEL_END_TEXT,
        },
        display: promotional?.countdown?.text || '',
      });
    }
    return labels;
  };

  useEffect(() => {
    let removeResizeEventListener = null;
    if (canFlipRef.current) {
      checkHeight();
      removeResizeEventListener = addEventListener(window, 'resize', ramdaDebounce(false, 80, checkHeight)());
      setTimeout(() => {
        runTimer();
      }, FLIP_START_SEC);
    }

    return () => {
      if (canFlipRef.current) {
        pauseTimer();
        removeResizeEventListener();
      }
    };
  }, []);

  const promo = promotional || { type: [] };
  const premiumCompareElement = comparables
    // eslint-disable-next-line no-underscore-dangle
    ? nth(0, comparables.filter(c => c && c.__typename === 'CompareElementPrice'))
    : null;

  let titleRoute;
  let imageRoute;
  const alias = urlAliasInfo?.metaData?.alias;
  if (alias) {
    titleRoute = getPageRoute(alias, language, vertical, ccProductPageRoutes);
    imageRoute = getPageRoute(alias, language, vertical, ccProductPageRoutes);
  } else if (provider?.alias) {
    imageRoute = getPageRoute(provider?.alias, language, vertical, providerProductPageRoute);
  }

  let allExcludedCountries = [];
  let allIncludedCountries = [];
  if (selectedInsuranceType === 'ANNUAL_PLAN') {
    if (selectedRegion === 'ASIA_PACIFIC' && region.includes('ASIA_PACIFIC')) {
      const allCountryStrings = [];
      allCountries.forEach(cl => cl.values.forEach(c => allCountryStrings.push(c.key)));
      let countriesToExclude = [];
      Object.values(excludedCountries).forEach((value) => {
        if (Array.isArray(value)) {
          countriesToExclude = countriesToExclude.concat(value);
        }
      });
      allIncludedCountries = _.difference(allCountryStrings, countriesToExclude);
      allIncludedCountries.sort();
    } else if (excludedCountries && Object.values(excludedCountries).length > 0) {
      Object.values(excludedCountries).forEach((value) => {
        if (Array.isArray(value)) {
          allExcludedCountries = allExcludedCountries.concat(value);
        }
      });
      allExcludedCountries.sort();
    }
  }

  const productPageLink = urlAliasInfo
    && titleRoute
    && encodeURI(`${titleRoute}?entry=header${list ? `&from=${list}` : ''}`);

  const getFlipInitClass = () => {
    if (timerValue === 0 && FLIP_START_SEC !== 0) return ' flip-init';
    return ' flip-in';
  };

  const toggleKGIModal = () => {
    const { track } = props;
    setShowModal(val => !val);
    setActiveQuestion(0);
    setKGIAnswer({
      COMPANY_TPYE: '',
      HAVE_MORE_THAN_ONE_YEAR_CC: '',
      FINAL_QUESTION: '',
      RESULT: '',
      ERR: '',
    });
    const genData = onKGIPopupEvent(list, props, !showModal ? 'open' : 'close');
    track({ data: genData });
  };

  const nextQuestion = () => {
    if (activeQuestion === 2) {
      if (KGIAnswer.FINAL_QUESTION === 'N' && KGIAnswer.HAVE_MORE_THAN_ONE_YEAR_CC === 'Y') {
        setActiveQuestion(4);
      } else {
        setActiveQuestion(val => val + 1);
      }
    }
    if (activeQuestion < 2) {
      setActiveQuestion(val => val + 1);
    }
  };

  const lastQuestion = () => setActiveQuestion(val => val - 1);

  const selectKGIRadio = (data) => {
    if (activeQuestion === 0) {
      setKGIAnswer({
        ...KGIAnswer,
        COMPANY_TPYE: data.value,
        HAVE_MORE_THAN_ONE_YEAR_CC: '',
        FINAL_QUESTION: '',
      });
    }
    if (activeQuestion === 1) {
      setKGIAnswer({
        ...KGIAnswer,
        HAVE_MORE_THAN_ONE_YEAR_CC: data.value,
        FINAL_QUESTION: '',
      });
    }
    if (activeQuestion === 2) {
      setKGIAnswer({
        ...KGIAnswer,
        FINAL_QUESTION: data.value,
      });
    }
  };

  const goToResultPage = () => {
    let productNameForTracking = '';
    let url = '';
    const { track } = props;

    if (KGIAnswer.COMPANY_TPYE === 'Y') {
      if (KGIAnswer.HAVE_MORE_THAN_ONE_YEAR_CC === 'Y') {
        if (KGIAnswer.FINAL_QUESTION === 'Y') {
          // 1 YYY
          productNameForTracking = '優-卡準-A';
          url = 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.236113773;dc_trk_aid=457532895;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=';
        } else {
          // 7 YYN
          productNameForTracking = '優-卡非準-無';
          url = 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.236113773;dc_trk_aid=457535622;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=';
        }
      } else if (KGIAnswer.FINAL_QUESTION === 'Y') {
        // 2 YNY
        productNameForTracking = '優-中華-B';
        url = 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.236113773;dc_trk_aid=457647766;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=';
      } else {
        // 3 YNN
        productNameForTracking = '優-非中華-C';
        url = 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.236113773;dc_trk_aid=457647769;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=';
      }
    } else if (KGIAnswer.HAVE_MORE_THAN_ONE_YEAR_CC === 'Y') {
      if (KGIAnswer.FINAL_QUESTION === 'Y') {
        // 4 NYY
        productNameForTracking = '卡準-D';
        url = 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.236113773;dc_trk_aid=457647772;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=';
      } else {
        // 8 NYN
        productNameForTracking = '卡非準-無';
        url = 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.236113773;dc_trk_aid=457535625;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=';
      }
    } else if (KGIAnswer.FINAL_QUESTION === 'Y') {
      // 5 NNY
      productNameForTracking = '中華-E';
      url = 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.236113773;dc_trk_aid=457647775;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=';
    } else {
      // 6 NNN
      productNameForTracking = '非中華-F';
      url = 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.236113773;dc_trk_aid=457647778;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=';
    }

    const productData = {
      brand: props?.provider?.providerName,
      name: `${productName}_${productNameForTracking}`,
      id: props?.title,
      productDetails: (props?.comparables || []).map(comparablesMappingHandler).join('|'),
      category: props?.__typename,
      dealStatus: props?.ctaButton?.show ? 'true' : 'false',
      currency: '',
      price: '',
      position: props?.index + 1,
      promoLabel: (props?.promotional?.type || []).map(t => t.display).join('|'),
      promotion: (props?.promotional?.type || []).map(t => t.key).join('|'),
      purchaseIntent: 'apply',
    };

    const genData = onKGIPopupApplyButtonClick(list, productData);
    track({ data: genData });
    if (activeQuestion === 4) {
      window.location.href = url;
    } else {
      window.open(`/external?url=${url}`, '_blank');
      toggleKGIModal();
    }
  };

  return (
    <>
      <Card className="product-pane" preserveShapeOnMobile dataSelectorId={title} dataSelectorIndex={index} dataSelectorType="product-card">
        <Link to={productPageLink} css={{ display: 'flex', padding: '0 !important' }}>
          <Card.Header>
            <Header
              name={productName}
              image={image}
              imageOrientation={imageOrientation}
              titleRoute={titleRoute}
              imageRoute={imageRoute}
              labels={getPromotionalLabels()}
              imageDimensions={imageDimensions}
              list={list}
              lazyLoadImg={lazyLoadImg}
              haveLimit={canCountdownRef.current}
            />
          </Card.Header>
        </Link>
        <Card.Content>
          <ConditionFlipWrapper
            condition={canFlipRef.current}
            wrapper={children => (
              <div className="flip-pane" style={{ height: heightValue }}>
                <div className="flip-container" onMouseEnter={() => pauseTimer()} onMouseLeave={() => runTimer()}>
                  <div ref={frontRef} className={`flip-inner flip-front${timerValue % 2 === 0 ? getFlipInitClass() : ' flip-hidden'}${canFlipRef.current ? '' : ' no-flip'}`}>
                    {children}
                  </div>
                  <div ref={backRef} onClick={onCtaClick(ctaButton, onCtaLinkClick)} className={`flip-inner flip-back ${timerValue % 2 === 0 ? 'flip-hidden' : 'flip-in'}`}>
                    <img className={`flip-back-img ${ctaButton?.show ? '' : 'no-link'}`} alt={productName} src={DESKTOP_IMAGE} />
                    <img className={`flip-back-img-mobile ${ctaButton?.show ? '' : 'no-link'}`} alt={productName} src={MOBILE_IMAGE} />
                  </div>
                </div>
              </div>
            )}
          >
            <Row
              name={productName}
              image={image}
              imageOrientation={imageOrientation}
              ctaButton={ctaButton}
              defaultCTALabel={staticText.defaultCTALabel}
              comparables={comparables}
              rowIndex={index}
              imageDimensions={imageDimensions}
              imageRoute={imageRoute}
              list={list}
              onCtaLinkClick={onCtaLinkClick}
              verticalEnum={verticalEnum}
              lazyLoadImg={lazyLoadImg}
              showModal={toggleKGIModal}
            />
            {ctaButton && ctaButton.show && (
              <TabletCtaButtonRow
                ctaButton={ctaButton}
                onCtaLinkClick={onCtaLinkClick}
                staticText={staticText}
                name={productName}
                showModal={toggleKGIModal}
              />
            )}
            {promo && (
              <PromotionalBanner
                onClick={toggleAccordionPanel}
                type={promo.type.length > 0 && promo.type[0].key}
                title={promo.type.length && promo.type[0].display}
                noBanner={!promo.type.length}
                description={promo.bannerText}
                descriptionImg={promo.bannerImage?.url}
                footnotes={
                  description ? description.shortDescription : []
                }
                rightComponent={(
                  <Button
                    text
                    rightIconName={isAccordionPanelShow ? 'chevron_up' : 'chevron_down'}
                    dataSelectorId="see-more"
                  >
                    {isAccordionPanelShow
                      ? staticText.accordionShowLess
                      : staticText.accordionShowMore}
                  </Button>
                )}
              />
            )}
          </ConditionFlipWrapper>
          <Collapsible isCollapsed={!isAccordionPanelShow} dataSelectorId="product-card-collapsible">
            <AccordionPanel
              features={features}
              offers={offers}
              apr={apr}
              fees={fees}
              eligibilityCriteria={eligibilityCriteria}
              disclaimer={disclaimer}
              staticText={staticText}
              documents={documents}
              provider={provider}
              updatedAt={updatedAt}
              termsAndConditions={termsAndConditions}
              excludedCountries={allExcludedCountries}
              includedCountries={allIncludedCountries}
              // TODO: Remove after exp end
              verticalEnum={verticalEnum}
              titleRoute={titleRoute}
              list={list}
            />
          </Collapsible>
          <MobileButtonGroup
            ctaButton={ctaButton}
            isAccordionPanelShow={isAccordionPanelShow}
            staticText={staticText}
            onShowMoreButtonClick={toggleAccordionPanel}
            premiumCompareElement={premiumCompareElement}
            onCtaLinkClick={onCtaLinkClick}
            isLearnMore={isLearnMore}
            onLearnMoreClick={onLearnMoreClick}
            urlAliasInfo={urlAliasInfo}
            titleRoute={titleRoute}
            list={list}
            name={productName}
            showModal={toggleKGIModal}
          />
        </Card.Content>
      </Card>
      {showModal && productName === '凱基銀行 個人信貸 超低利率專案' && (
        <div className="kgi-modal-view">
          <Modal
            modalBoxClassName="kgi-modal-box"
          >
            <div className={`kgi-modal-top${activeQuestion > 2 ? ' final' : ''}`}>
              <Heading className="kgi-modal-top-heading" as="h4" primary>
                {activeQuestion < 3 && '請協助我們完成以下三個問題，以加快您的申辦流程'}
              </Heading>
              <Button className="kgi-modal-top-close-icon-button" onClick={toggleKGIModal} text>
                <Icon name="cancel" medium primary />
              </Button>
            </div>
            {activeQuestion < 3 && (
              <div className="kgi-modal-body">
                <Heading as="h4" primary>
                  {KGIQuestion[KGIFlow[activeQuestion]]?.subTitle}
                </Heading>
                <Heading as="h3" primary>
                  {KGIQuestion[KGIFlow[activeQuestion]]?.title}
                </Heading>
                {
                  KGIFlow.map((item, kgiFlowIndex) => (
                    kgiFlowIndex === activeQuestion && (
                      <RadioControl
                        idPrefix="kgiRadio"
                        options={KGIQuestion[item]?.radioGroup}
                        onChange={selectKGIRadio}
                        value={KGIAnswer[item]}
                      />
                    )
                  ))
                }
              </div>
            )}
            {activeQuestion > 2 && (
              <div className="kgi-modal-body final">
                <Heading as="h2" primary>
                  {KGIQuestion[KGIFlow[activeQuestion]]?.title}
                </Heading>
                <Heading as="h3" primary>
                  {KGIQuestion[KGIFlow[activeQuestion]]?.subTitle}
                </Heading>
              </div>
            )}
            <div className={`kgi-modal-bottom${activeQuestion > 2 ? ' final' : ''}`}>
              {
                (KGIFlow.map((item, kgiFlowIndex) => {
                  if (kgiFlowIndex === activeQuestion) {
                    return (KGIQuestion[item]?.btnGroup || []).map((btnItem, btnIndex) => {
                      switch (btnIndex) {
                        case 0:
                          if (KGIQuestion[item]?.btnGroup.length > 1) {
                            return <Button tertiary onClick={lastQuestion} leftIconName="arrow_backward">{btnItem?.label}</Button>;
                          }
                          if (activeQuestion > 2) {
                            return (
                              <Button primary onClick={goToResultPage}>{btnItem?.label}</Button>
                            );
                          }
                          return <Button primary disabled={KGIAnswer[item] === ''} onClick={nextQuestion} rightIconName="arrow_forward">{btnItem?.label}</Button>;
                        case 1:
                          if (activeQuestion > 1) {
                            return <Button primary disabled={KGIAnswer[item] === ''} onClick={nextQuestion}>{btnItem?.label}</Button>;
                          }
                          if (activeQuestion > 2) {
                            return <Button primary onClick={nextQuestion}>{btnItem?.label}</Button>;
                          }
                          return <Button primary disabled={KGIAnswer[item] === ''} onClick={nextQuestion} rightIconName="arrow_forward">{btnItem?.label}</Button>;
                        default:
                          return null;
                      }
                    });
                  }
                  return null;
                }))}
            </div>
          </Modal>
        </div>
      )}
    </>
  );
};

ProductPane.defaultProps = {
  offers: null,
  apr: null,
  fees: null,
  eligibilityCriteria: null,
  comparables: [],
  disclaimer: null,
  updatedAt: null,
  features: null,
  documents: null,
  promotional: {},
  provider: null,
  description: null,
  featured: false,
  ctaButton: null,
  onCtaLinkClick: null,
  track: null,
  list: null,
  verticalEnum: null,
  urlAliasInfo: null,
  ccProductPageRoutes: '',
  providerProductPageRoute: '',
  title: '',
  excludedCountries: {},
  imageOrientation: null,
  allCountries: [],
  selectedRegion: '',
  selectedInsuranceType: '',
  region: [],
  lazyLoadImg: true,
  countdownFormat: {},
  enableFlipBanner: false,
};

ProductPane.propTypes = {
  comparables: arrayOf(shape({
    id: string.isRequired,
    displayValue: string.isRequired,
    sortValue: number.isRequired,
    title: shape({
      key: string,
      display: string,
    }),
    description: string,
    tooltip: string,
    prefix: string,
    suffix: string,
  })),
  offers: shape({
    welcome: shape({
      description: string,
      conditions: string,
    }),
  }),
  apr: arrayOf(
    shape({
      type: shape({}),
      value: string,
    })
  ),
  fees: arrayOf(
    shape({
      type: shape({}),
      value: string,
    })
  ),
  productName: string.isRequired,
  staticText: shape({}).isRequired,
  imageDimensions: shape({}).isRequired,
  features: shape({
    title: string,
    pros: arrayOf(string).isRequired,
    cons: arrayOf(string).isRequired,
  }),
  image: shape({
    url: string.isRequired,
    alt: string,
  }).isRequired,
  ctaButton: shape({
    show: bool.isRequired,
    label: string.isRequired,
    isInternalLink: bool,
    link: shape({
      url: string.isRequired,
    }),
  }),
  documents: arrayOf(shape({
    name: string,
    url: string,
  })),
  promotional: shape({
    type: arrayOf(shape({})),
    bannerText: string,
    bannerImage: shape({
      url: string,
    }),
    description: shape({}),
  }),
  provider: shape({
    id: string,
    alias: string,
    name: string,
  }),
  eligibilityCriteria: arrayOf(
    shape({
      type: shape({}).isRequired,
      value: string,
    })
  ),
  termsAndConditions: string,
  description: shape({}),
  disclaimer: string,
  updatedAt: string,
  index: number.isRequired,
  featured: bool,
  onCtaLinkClick: func,
  onLearnMoreClick: func,
  track: func,
  list: string,
  verticalEnum: string,
  urlAliasInfo: shape({}),
  ccProductPageRoutes: string,
  providerProductPageRoute: string,
  vertical: string.isRequired,
  language: string.isRequired,
  title: string,
  excludedCountries: shape({}),
  imageOrientation: string,
  allCountries: arrayOf(shape({})),
  selectedInsuranceType: string,
  selectedRegion: string,
  region: arrayOf(string),
  lazyLoadImg: bool,
  isLearnMore: bool,
  countdownFormat: shape({}),
  enableFlipBanner: bool,
};

export default withTracking(withApplicationConfig(ProductPane, ['routes', 'productPane']));
